import React from 'react';
import { useSelector } from 'react-redux';

import { ContentClass } from '../../app/Shared/enums';
import {
  selectAuthFeatureFlags,
  selectHasAudioSubscription,
  selectHasVideoSubscription,
} from '../../auth/AuthSelectors';
import useMedia from '../../common/hooks/useMedia';
import SnapshotVideoThumbnail from '../components/SnapshotVideoThumbnail';
import StockItemContributor from '../components/StockItemContributor';
import StockItemInfo from '../components/StockItemInfo';
import StockItemTitle from '../components/StockItemTitle';
import DownloadCtaButton from '../components/buttons/DownloadCtaButton';
import ReportErrorButton from '../components/buttons/ReportErrorButton';
import SimilarStockItemButton from '../components/buttons/SimilarStockItemButton';
import FormatSelector from '../components/download/FormatSelector';
import MemberDetailsDownloadInfo from '../components/download/cta/MemberDetailsDownloadInfo';
import DownloadsRemaining from '../components/download/messaging/DownloadsRemaining';
import { selectDetailsStockItem } from '../selectors/detailsSelectors';

const StockItemInformationContainer = () => {
  const stockItem = useSelector(selectDetailsStockItem);
  const { useSnapshotsUI } = useSelector(selectAuthFeatureFlags);
  const mediaQuery = useMedia('(max-width: 1199px)', false);
  const hasOtherSubscriptions = Boolean(
    useSelector(selectHasAudioSubscription) ||
      useSelector(selectHasVideoSubscription)
  );
  return (
    <>
      <div className="flex flex-col xl:flex-row bg-gray-900 rounded-2xl mx-4 overflow-hidden">
        <div className="flex flex-grow-2 relative flex-column justify-between bg-gray-950 rounded-t-2xl xl:w-3/4 xl:max-w-3/4 overflow-hidden">
          <SimilarStockItemButton text="Similar Images" />
          <div className="bg-gray-950 xl:min-h-136 flex items-center xl:rounded-tr-none overflow-hidden">
            <img
              src={stockItem.previewUrl}
              alt={stockItem.title}
              className="max-w-full max-h-138 w-auto my-0 mx-auto"
              loading="eager"
            />
          </div>
          {!mediaQuery && <StockItemInfo />}
        </div>
        <div className="flex flex-column md:mx-6 xl:w-1/4 min-w-1/4 text-white">
          <div className="downloadOptions-row relative flex flex-col flex-1 mx-4 md:mx-0 justify-evenly text-white">
            <div className="flex flex-col justify-center">
              {!mediaQuery && (
                <div className="text-lg text-center">
                  <DownloadsRemaining />
                </div>
              )}
              <MemberDetailsDownloadInfo
                needsToUpgrade={false}
                contentTypesString={'photos, vectors, and illustrations'}
                className="text-white"
                isVideoDetailsPage={false}
              />
              <StockItemTitle />
              <StockItemContributor />
              <FormatSelector />
              <DownloadCtaButton
                contentClass={ContentClass.Image}
                hasOtherSubscriptions={hasOtherSubscriptions}
              />
            </div>
            {useSnapshotsUI && stockItem.snapshotVideo && (
              <SnapshotVideoThumbnail snapshotVideo={stockItem.snapshotVideo} />
            )}
          </div>
          {mediaQuery && <StockItemInfo />}
          {!mediaQuery && (
            <div className="relative mb-4 text-right mt-4 lg:mt-0">
              <ReportErrorButton stockItemId={stockItem.id} />
            </div>
          )}
        </div>
      </div>
      {mediaQuery && (
        <div className="mt-4 text-center">
          <ReportErrorButton stockItemId={stockItem.id} color="black" />
        </div>
      )}
    </>
  );
};

export default StockItemInformationContainer;
